import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { PrimaryButton } from "components/Buttons";
import { useAuth } from "hooks";
import { UserInviteForm } from "components/Settings/Users";
import { GET_ORGANIZATION } from "graphql/queries";
import { USER_TYPES } from "constants/index";
import { isVisibleToRole } from "utils";

const COMPONENT_ALLOWED_ROLES = [USER_TYPES.admin, USER_TYPES.client];

/**
 * AddContactButton
 */
const AddContactButton = (props) => {
  const [showForm, setShowForm] = useState(false);
  const { isAdmin, isClient, roles } = useAuth();

  if (!isVisibleToRole(COMPONENT_ALLOWED_ROLES, roles)) return null;

  const formProps = isClient
    ? {
        titleId: "Settings.Users.CollaboratorInviteForm.Title",
        titleValues: {},
        successMsgId: "Settings.Users.CollaboratorInviteForm.CreateSuccess",
      }
    : {};

  return (
    <>
      <PrimaryButton onClick={() => setShowForm(true)}>
        <FormattedMessage id={`Organization.Organization${isAdmin ? "Contact" : "Collaborator"}.AddButtonTitle`} />
      </PrimaryButton>
      <UserInviteForm
        show={showForm}
        onClose={() => setShowForm(false)}
        isEditing={false}
        refetchQuery={GET_ORGANIZATION}
        {...props}
        {...formProps}
      />
    </>
  );
};

export default AddContactButton;
